import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    
    {
      // =============================================================================
      // Main layout routes
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Routes
        // =============================================================================
        {
          path: '/',
          redirect: 'settings/general/',
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'settings/general/',
          name: 'general',
          component: () => import('./views/Content'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'settings/users/',
          name: 'credits',
          component: () => import('./views/users/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'content/services/',
          name: 'services',
          component: () => import('./views/services/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'content/home/',
          name: 'home',
          component: () => import('./views/Home'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'content/clients/',
          name: 'clients',
          component: () => import('./views/clients/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: 'content/posts/',
          name: 'clients',
          component: () => import('./views/posts/App'),
          meta: {
            rule: 'admin',
            authRequired: true
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('./views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        }
      
      ]
    },
    // Full Page Layout
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/login/Login.vue'),
          meta: {
            rule: 'editor',
          }
        },
        // Redirect to 404 page, if no match found
        {
          path: '*',
          redirect: '/pages/error-404',
          meta: {
            rule: 'editor'
          }
        }
      ]
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    
    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser
    
    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {
      if (!(firebaseCurrentUser)) {
        router.push({path: '/pages/login', query: {to: to.path}})
      }
    }
    
    return next()
    
  })
  
})

export default router
